module.exports = __webpack_public_path__ + "img/d_sv5.b37fe98.png";